// extracted by mini-css-extract-plugin
module.exports = {"hover":"NotFound_hover___w7j0"};